import React from 'react';
import useTranslate from '../../../common/hooks/useTranslate';
import InvestorDropdownFilter from '../../ui/filters/investorDropdownFilter/investorDropdownFilter';
import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';

import './header.scss';

interface IHeader {
  title: string;
  additionalTitle?: string;
  onInvestorChange?: (event: DropDownListChangeEvent) => void;
  investorDropdown?: boolean;
  children?: any;
  investors?: any;
}

const Header: React.FC<IHeader> = ({ title, additionalTitle, onInvestorChange, investorDropdown, children, investors }) => {
  const { t } = useTranslate();

  const handleChange = (event: DropDownListChangeEvent) => {
    if (onInvestorChange) {
      onInvestorChange(event);
    }
  };

  return (
    <div className="header-wrapper">
      <div className="title-wrapper">
        <span className="titleHead">{t(title)}</span>
        <span className="titleHead titleGrey">{t(additionalTitle)}</span>
        {investorDropdown && <InvestorDropdownFilter onChangeCallback={handleChange} investors={investors} />}
      </div>
      <div className="headerContent">{children}</div>
    </div>
  );
};

export default Header;
